var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M1.4875 9.07028L7.13438 14.3422C7.36875 14.5609 7.67812 14.6828 8 14.6828C8.32187 14.6828 8.63125 14.5609 8.86563 14.3422L14.5125 9.07028C15.4625 8.18591 16 6.94528 16 5.64841V5.46716C16 3.28278 14.4219 1.42028 12.2688 1.06091C10.8438 0.82341 9.39375 1.28903 8.375 2.30778L8 2.68278L7.625 2.30778C6.60625 1.28903 5.15625 0.82341 3.73125 1.06091C1.57812 1.42028 0 3.28278 0 5.46716V5.64841C0 6.94528 0.5375 8.18591 1.4875 9.07028Z",
          fill: "#F10519",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }